import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './servicesClients.scss';

import { clientesLogos } from './clientes/clienteslogos';

const ServicesClients = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);
    const logosRefs = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });

        const logosObservers = logosRefs.current.map((logoRef) => {
            if (!logoRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('services-clients__content-img--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(logoRef);
            return observer;
        });

        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
            logosObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    return (
        <div className="services-clients" >
            <section className="services-clients__section">
                <div className="services-clients__content">
                    <h1 className="services-clients__title content__title-backgroundDark">{t('services.clients.title')}</h1>
                    <div
                        ref={el => lineRefs.current[0] = el}
                        className="content__title-line"
                    />
                    <div
                        className="services-clients__text"
                    >
                        <p className='services-clients__text-paragraph content__text-title-backgroundDark'>
                            {t('services.clients.desc')}
                        </p>
                    </div>
                </div>
                <div className='services-clients__content-clients'>
                    {clientesLogos.map((logo, index) => (
                        <div key={logo.id} className='services-clients__content-container-img'>
                            <img
                                ref={(el) => logosRefs.current[index] = el}
                                className='services-clients__content-img'
                                src={logo.photo}
                                alt={`Cliente ${logo.id}`}
                            />
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}

export default ServicesClients